"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BurgerText32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M32 32H0v-1h32v1zm0-8H0v-1h32v1zm0-9v1H0v-1h32zM26.47 1.908v5.471c0 .768.196 1.35.588 1.746.392.396.959.594 1.697.594.702 0 1.234-.198 1.6-.594.365-.396.548-.978.548-1.746V1.908H32v5.471c0 1.096-.283 1.918-.844 2.466-.561.548-1.362.822-2.401.822-1.062 0-1.89-.262-2.487-.786-.597-.524-.896-1.358-.896-2.502V1.908h1.098zm-24.969 0l2.597 7.199 2.609-7.199h1.5v8.567H7.168V3.348h-.023l-2.574 7.127h-.935L1.062 3.348h-.023v7.127H0V1.908h1.501zm14.223 0v.96h-4.595v2.723h4.283v.96h-4.283v2.964h4.629v.96h-5.726V1.908h5.692zm2.516 0l4.34 6.947h.023V1.908h1.039v8.567h-1.201L18.135 3.6h-.023v6.875h-1.038V1.908h1.166zM28.121 0v1.248h-1.039V0h1.039zm2.17 0v1.248h-1.039V0h1.039z", className: "burger-text-32_svg__path-1" }))); };
var StyledBurgerText32 = styled_components_1.default(BurgerText32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledBurgerText32;
var templateObject_1;
//# sourceMappingURL=BurgerText32.js.map